import type { DivIcon } from 'leaflet';
import type { CategoryGlyphIcon } from '@/shared/lib/category-icon';
import { divIcon } from 'leaflet';
import { renderToStaticMarkup } from 'react-dom/server';
import { MapIconGlyph } from './map-icon-glyph';

const ICON_SIZE = 30;
// slate-700 — the legacy map's dark circular badge colour.
const DEFAULT_COLOR = '#334155';
// A singled-out marker: a warm grey, set apart from the dark slate pins by
// its size, white ring and pulse rather than by a loud colour.
export const HIGHLIGHT_COLOR = '#7a766e';

// Renders a category glyph into a Leaflet `L.divIcon` circular badge
// (legacy parity: dark circle + white glyph). Caller supplies the resolved
// glyph (e.g. `getMarkerGlyph(category, subcategory)`) so this module stays
// domain-agnostic — it never imports product/itinerary helpers.
export const buildMapIcon = ({
  Icon,
  color,
  strokeWidth = 1,
  highlighted = false,
}: {
  Icon: CategoryGlyphIcon;
  color?: string;
  strokeWidth?: number;
  /** Bigger, grey-ringed and pulsing (see `MapIconGlyph`). */
  highlighted?: boolean;
}): DivIcon => {
  const html = renderToStaticMarkup(
    <MapIconGlyph
      Icon={Icon}
      color={color ?? (highlighted ? HIGHLIGHT_COLOR : DEFAULT_COLOR)}
      highlighted={highlighted}
      strokeWidth={strokeWidth}
    />
  );
  return divIcon({
    className: highlighted
      ? 'shared-map-marker shared-map-marker-is-highlighted'
      : 'shared-map-marker',
    html,
    iconSize: [ICON_SIZE, ICON_SIZE],
    // Circle marks the point itself — anchor at its centre.
    iconAnchor: [ICON_SIZE / 2, ICON_SIZE / 2],
    popupAnchor: [0, -ICON_SIZE / 2],
  });
};
